import React from "react";
import {
  Col,
  Row,
  Input,
  Label,
  FormFeedback,
  Button,
} from "reactstrap";

interface DeliveryChargeFormProps {
  validation: any;
  isEdit?: boolean;
}

const priorityOptions = [
  { label: "Low", value: 1 },
  { label: "Medium", value: 2 },
  { label: "High", value: 3 },
];

const TicketCategoryForm: React.FC<DeliveryChargeFormProps> = ({
  validation,
  isEdit = false,
}) => {
  return (
    <form onSubmit={validation.handleSubmit}>
      <div className="px-3 py-2">
        <h5>{isEdit ? "Edit Category" : "New Category"}</h5>

        {/* Category Name */}
        <Row className="g-3 mt-2">
          <Col md={12}>
            <Label>Category Name <span className="text-danger">*</span></Label>
            <Input
              name="categoryname"
              value={validation.values.categoryname}
              onChange={validation.handleChange}
              invalid={
                !!(
                  validation.touched.categoryname &&
                  validation.errors.categoryname
                )
              }
              placeholder="Enter category name"
            />
            <FormFeedback>
              {validation.errors.categoryname}
            </FormFeedback>
          </Col>
        </Row>

        {/* Priority Dropdown */}
        <Row className="g-3 mt-2">
          <Col md={12}>
            <Label>Priority <span className="text-danger">*</span></Label>
            <Input
              type="select"
              name="priority"
              value={validation.values.priority}
              onChange={validation.handleChange}
              invalid={
                !!(validation.touched.priority && validation.errors.priority)
              }
            >
              <option value="">Select priority</option>
              {priorityOptions.map((item) => (
                <option key={item.value} value={item.value}>
                  {item.label}
                </option>
              ))}
            </Input>
            <FormFeedback>
              {validation.errors.priority}
            </FormFeedback>
          </Col>
        </Row>

        {/* Submit */}
        <div className="d-flex justify-content-end mt-4">
          <Button color="primary" type="submit">
            {isEdit ? "Update" : "Done"}
          </Button>
        </div>
      </div>
    </form>
  );
};

export default TicketCategoryForm;
